var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page",class:{ pcStyle: _vm.isPc, mobileStyle: _vm.isMobile }},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-tips"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"icon-box"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/failed.png"),"alt":""}})])])])
}]

export { render, staticRenderFns }